<eco-fab-speed-dial
  [(open)]="open"
  [direction]="direction"
  [animationMode]="animationMode"
  [fixed]="fixed"
>
  <eco-fab-speed-dial-trigger [spin]="spin">
    <button mat-fab>
      <mat-icon class="spin180">add</mat-icon>
    </button>
  </eco-fab-speed-dial-trigger>

  <eco-fab-speed-dial-actions>
    <button mat-mini-fab (click)="eraseAction()" class="showTooltipDelete">
      <div class="mensaje">{{ button3 | translate }}</div>
      <mat-icon>delete</mat-icon>
    </button>
    <button
      *ngIf="isDashboard()"
      mat-mini-fab
      (click)="createWidget()"
      class="showTooltipDelete"
    >
      <div class="mensaje">{{ button2 }}</div>
      <mat-icon>bar_chart</mat-icon>
    </button>
    <button
      *ngIf="!isDashboard() && !generated"
      mat-mini-fab
      (click)="createAction()"
      class="showTooltipDelete"
    >
      <div class="mensaje">{{ button1 | translate }}</div>
      <mat-icon *ngIf="!isDashboard()">bar_chart</mat-icon>
      <mat-icon *ngIf="isDashboard()">dashboard</mat-icon>
    </button>
  </eco-fab-speed-dial-actions>
</eco-fab-speed-dial>
